// extracted by mini-css-extract-plugin
export default {"container":"EventReminderInput_container__zZds3","customReminderRow":"EventReminderInput_customReminderRow__89P-D"};